import { useState } from 'react';
import { useSelector } from 'react-redux';

import swal from 'sweetalert';

export default function AutomatedMenu() {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [menuData, setMenuData] = useState(null);
  const user = useSelector(state => state.session.user);

  console.log(user)

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    setFile(selectedFile);
    setPreviewUrl(URL.createObjectURL(selectedFile));
  };

  const handleUploadToGPT = async () => {
    if (!file) return;
    setIsUploading(true);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await fetch('/api/items/parse-menu', {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();
      setMenuData(data);
    } catch (err) {
      console.error('Error uploading to GPT:', err);
    }

    setIsUploading(false);
  };

  const handleInputChange = (catIndex, itemIndex, field, value) => {
    const updated = [...menuData];
    updated[catIndex].items[itemIndex][field] = value;
    setMenuData(updated);
  };

  const handleCategoryChange = (catIndex, value) => {
    const updated = [...menuData];
    updated[catIndex].category = value;
    setMenuData(updated);
  };

  const handleConfirmSubmit = async () => {
    if (!menuData) return;
  
    try {
      const res = await fetch('/api/items/add-multiple-items', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: menuData, restaurant_id: user?.restaurant_id }),
      });
  
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData?.error || 'Something went wrong.');
      }
  
      swal('✅ Success', 'Items added successfully!', 'success');
      setMenuData(null);
      setFile(null);
      setPreviewUrl('');
    } catch (err) {
      console.error('Submit error:', err);
      swal('❌ Submission Failed', err.message + 'most likely due to price must be dec exmaple 9.99', 'error');
    }
  };

  return (
    <div className="container ">
      <h2 className="mb-4">Automated Menu Uploader (1 photo or pdf at a time)</h2>

      <div className="mb-3">
        <input className="form-control" type="file" accept=".pdf,image/*" onChange={handleFileChange} />
      </div>

      {previewUrl && (
        <div className="mb-4">
          <p className="fw-semibold">Preview:</p>
          {file.type.includes('image') ? (
            <img src={previewUrl} alt="preview" className="img-thumbnail" style={{ maxWidth: '200px' }} />
          ) : (
            <p>{file.name}</p>
          )}
        </div>
      )}

      <button
        onClick={handleUploadToGPT}
        disabled={!file || isUploading}
        className="btn btn-primary mb-4"
      >
        {isUploading ? 'Processing Please Wait...' : 'Extract Menu Info'}
      </button>
<br />
      {menuData && (
<>
            <span className='text-danger'>AI sometimes can make errors, please check generated menu carefully,
                <br />
                Submit button on the bottom after editing and reviewing.
            </span>
          <div className="border rounded p-3 bg-light">
          <h4 className="mb-3">✏️ Edit Menu Before Submission (You can always edit menu later)</h4>

          {menuData.map((categoryObj, catIndex) => (
            <div key={catIndex} className="mb-5 p-3 border rounded bg-white shadow-sm">
              <input
                type="text"
                value={categoryObj.category}
                onChange={(e) => handleCategoryChange(catIndex, e.target.value)}
                className="form-control mb-3 fw-bold"
                placeholder="Category Name"
              />

              {categoryObj.items.map((item, itemIndex) => (
                <div key={itemIndex} className="mb-3 p-3 border rounded bg-light">
                  <div className="row g-2">
                    <div className="col-md-3">
                      <input
                        type="text"
                        value={item.name}
                        onChange={(e) => handleInputChange(catIndex, itemIndex, 'name', e.target.value)}
                        className="form-control"
                        placeholder="Item Name"
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="text"
                        value={item.chinese_name || ''}
                        onChange={(e) => handleInputChange(catIndex, itemIndex, 'chinese_name', e.target.value)}
                        className="form-control"
                        placeholder="Second Language(optional)"
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="text"
                        value={item.description || ''}
                        onChange={(e) => handleInputChange(catIndex, itemIndex, 'description', e.target.value)}
                        className="form-control"
                        placeholder="Description (optional)"
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        value={item.price}
                        onChange={(e) => handleInputChange(catIndex, itemIndex, 'price', e.target.value)}
                        className="form-control"
                        placeholder="Price"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}

          <button
            onClick={handleConfirmSubmit}
            className="btn btn-success"
          >
            ✅ Confirm and Submit
          </button>
        </div>
        </>
      )}
    </div>
  );
}
